import { Paper, Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import StoryProgressOverall from '../Crosspage/StoryProgressOverall';
import { deeplKey } from '../../config';
import translate from "deepl";
import { useTranslation } from 'react-i18next';


export default function IntroChoice(props) {

    const [hoverElevation, setHoverElevation] = useState(1);
    const [buttonTexts, setButtonTexts] = useState(props.buttonText);

    const {i18n} = useTranslation()

    useEffect(() => {
        if (i18n.language != "de") {
            translate({
                free_api: true,
                text: props.buttonText,
                target_lang: i18n.language,
                auth_key: deeplKey,
                source_lang: "DE"
            })
              .then(result => {
                setButtonTexts(result.data.translations.map(v => v.text))
            })
              .catch(error => {
                  console.error(error)
            });
        } else {
            setButtonTexts(props.buttonText)
        }
    }, [props.buttonText, i18n.language])

    const handleHover = (value) => {
        setHoverElevation(value);
    }

    const foundBestPath = props.storyProgress ? props.storyProgress.foundBestPath : false;
    const paths_done = props.storyProgress ? props.storyProgress.finishedPaths.length : 0;

    return(
        <Box>
        <Paper
            elevation={hoverElevation}
            onMouseOver={() => handleHover(3)}
            onMouseLeave={() => handleHover(1)}
            onClick={() => props.moveToStory()}
            sx={{
                backgroundColor: "primary.lightest",
                p: {xs: 1, sm: 2, md: 3},
                '&:hover': {
                    cursor: "pointer"
                },
            }}
        >
            <StoryProgressOverall foundBestPath={foundBestPath} n_done={paths_done} n_paths={props.n_choices}/>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    flexDirection: "row-reverse",
                }}
            >
                <Box>
                    <Typography>{buttonTexts[0]}</Typography>
                    <Typography>{buttonTexts[1]}</Typography>
                    <TouchAppIcon color="secondary" fontSize="large"/>
                </Box>
                <Box sx={{
                            display: "flex",
                            width: "auto"
                            // flexShrink: 1
                        }}>
                    <img style={{height: 300}} src={props.image} alt={props.imageDescription}/> 

                </Box>
            </Box>
        </Paper>
        </Box>
    )
}